import React from "react";
import { inject, observer } from "mobx-react";
import Header from "../../sharedComponents/header/header";
import DropDown from "../../sharedComponents/dropDown/dropDown";
import { DropDownModel } from "../../../helpers/dropDown";
import { ClientStore } from "../../../stores/clientStore";
import { PeselUtility } from "../../../helpers/peselUtility";
import { ClientLegalForm } from "../../../helpers/client";

interface InsuredInSecondOpinionProps {
  clientStore?: ClientStore;
}

@inject("clientStore")
@observer
export default class InsuredInSecondOpinion extends React.Component<InsuredInSecondOpinionProps> {
  constructor(props: InsuredInSecondOpinionProps) {
    super(props);
    const items = this.getItems();
    if (items.length) {
      this.props.clientStore!.setInsuredInSecondOpinion(items[0].id);
    }
  }

  public render() {
    return (
      <div className="section second-opinion">
        <Header type="medium" mainHeader="Ubezpieczony Second Opinion – Druga Opinia Medyczna" />
        <div className="question-answer-container">
          <div className="question">Ubezpieczony</div>
          <DropDown
            onChange={(value) => {
              this.props.clientStore!.setInsuredInSecondOpinion(value);
            }}
            value={this.getValue()}
            items={this.getItems()}
          />
        </div>
      </div>
    );
  }

  private getValue() {
    const insuredInSecondOpinion = this.props.clientStore!.insuredInSecondOpinion;

    if (insuredInSecondOpinion) {
      return insuredInSecondOpinion.pesel.value;
    }

    return "";
  }

  private getItems() {
    const clients: DropDownModel[] = [];

    this.props.clientStore!.insureds.forEach(insured => {
      const isAgeUnder65 = !PeselUtility.isAgeOver65FromPesel(insured.pesel.value);
      const privetLegalForm = insured.legalForm.value === ClientLegalForm.PRIVATE;
      const soleProprietorshipLegalForm = insured.legalForm.value === ClientLegalForm.SOLE_PROPRIETORSHIP;

      if (isAgeUnder65 && (privetLegalForm || soleProprietorshipLegalForm)) {
        clients.push({
          id: insured.pesel.value,
          displayName: `${insured.firstName.value} ${insured.lastName.value} ${insured.pesel.value}`
        });
      }
    });

    return clients;
  }
}
